export default __webpack_public_path__ + "static/aircall-hero-1-90a999819595d617e6e8842cce0a296f.png";